import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { IMAGES, COMPANY, CAPABILITIES } from "@/lib/site";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow={`About · ${COMPANY.city}`}
        title={<>An industrial coating shop<br /><span className="text-[#FF5722]">built like a manufacturer.</span></>}
        subtitle={`We are a Tennessee-based powder coating, blasting, and chemical stripping facility engineered for volume, precision, and repeatability — from OEM programs to one-off restoration parts.`}
        image={IMAGES.warehouse}
      />

      <section className="section px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="eyebrow mb-4">Our Story</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight tracking-tight">
            From a fabricator's need for a coater who could <span className="text-[#FF5722]">actually deliver.</span>
          </h2>
        </div>
        <div className="lg:col-span-7 space-y-6 text-zinc-300 leading-relaxed">
          <p>
            {COMPANY.name} was founded in {COMPANY.city} to solve a common frustration in the Southeast
            industrial market: too many coating shops promising volume, quality, and lead time — but delivering only two of the three.
          </p>
          <p>
            Today our {COMPANY.facilitySqFt} square foot facility is built to hold all three. Two large-capacity powder coating ovens
            and two spray booths run in parallel. A walk-in blast room handles structural steel, weldments,
            and delicate substrates alike. A dedicated chemical strip tank removes powder, paint, and e-coat
            without destroying thin-gauge aluminum.
          </p>
          <p>
            We handle parts up to {COMPANY.maxLength} long and {COMPANY.maxWidth} wide — a size range most shops
            in the region simply cannot accommodate. Forklifts and overhead handling keep large weldments moving safely.
            3D-printed masking fixtures give us repeatable protection on threads, bores, and mating surfaces run after run.
          </p>
          <p>
            The result: contractors, fabricators, architects, engineers, and manufacturers get one coating
            partner they can standardize on — with documented QC and one point of accountability.
          </p>
        </div>
      </section>

      <section className="section px-6 lg:px-10 border-t border-white/10 bg-[#0B0B0D]">
        <div className="eyebrow mb-4">By the Numbers</div>
        <h2 className="font-display text-4xl md:text-6xl tracking-tighter mb-12">A facility, not a garage.</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t border-l border-white/10">
          {CAPABILITIES.map(c => (
            <div key={c.label} className="border-r border-b border-white/10 p-6">
              <div className="text-xs uppercase tracking-widest text-zinc-500">{c.label}</div>
              <div className="font-display text-2xl md:text-3xl mt-2 tracking-tight">{c.value}</div>
            </div>
          ))}
        </div>
      </section>

      <CTABand title={<>Talk to a coater who can actually <span className="text-[#FF5722]">deliver.</span></>} />
    </div>
  );
}
